import InlineLink from './InlineLink'

export default InlineLink
